export const KEYS = {
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    V: 'v',
    TAB: 'Tab',
    ENTER: 'Enter',
};
